import React, { useEffect, useState } from "react";
import "./style.css";
import { months} from "../../Components/Apis/apis";
import BarChart from "../../Components/barChart/barChart";
import SideBar from "../../Components/Navbar/Sidebar";
import { Dropdown, DropdownButton } from "react-bootstrap";
import { getAllOrder, allInCartdata } from "../../Components/Apis/apis";

const Order = () => {
  const [year, setYear] = useState("");
  const [month, setMonth] = useState("");
  const [state, setstate] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [filterD, setFilterD] = useState([]);
  const [incart, setinCart] = useState([]);
  const [filterInCartData, setFilterInCartData] = useState([]);
  const [filterInCartD, setFilterInCartD] = useState([]);

  const clients = async () => {
    const data = await getAllOrder();
    data.map((el) => {
      el["year"] = el.start_date.slice(0, 4);
      el["month"] = el.start_date.slice(5, 7);
    });
    setstate(data);
    setFilterData(data);
    setFilterD(data);
  };


  const inCart = async () => {
    const data = await allInCartdata();

    data.map((el) => {
      el["year"] = el.create_date.slice(0, 4);
      el["month"] = el.create_date.slice(5, 7);
    });
    setinCart(data);
    setFilterInCartData(data);
    setFilterInCartD(data);
  };

  const allyaers = state.map((el) => el.year);
  const yearss = [...new Set(allyaers)];
  const years= yearss.filter((el) => el !== "0000");

  const filterYear = async () => {
    const data = state.filter((el) => el.year == year);
    setFilterData(data);
    setFilterD(data);

    const dataC = incart.filter((el) => el.year == year);
    setFilterInCartData(dataC);
    setFilterInCartD(dataC);
    setMonth("");
  };

  const filterMonth = async () => {
    let selectmonth = [];
    let selectmonthC = [];

    months.map((el) => {
      if (el.lable == month) {
        selectmonth.push(el.value);
        selectmonthC.push(el.value);
      }
    });

    const data = filterData.filter((el) => el.month == [...selectmonth]);
    const dataCart = filterInCartData.filter(
      (el) => el.month == [...selectmonthC]
    );

    setFilterD(data);
    setFilterInCartD(dataCart);
  };

 
  useEffect(() => {
    filterMonth();
  }, [month]);
  useEffect(() => {
    filterYear();
  }, [year]);

  useEffect(() => {
    clients();
    inCart();
  }, []);

  return (
    <div className="containers">
      <div className="container-sidebar">
        <SideBar />
      </div>
      <div className="container-pages">
        <div className="page-title">
          <h2>
            Total orders
            <div className="float-end me-4">
              {" "}
              <DropdownButton
                title={year ? <>Year {year}</> : <> Select year </>}
                id="select-media-box"
                onSelect={(e) => setYear(e)}
                className="  ms-2"
              >
                {years.map((el, i) => (
                  <Dropdown.Item eventKey={el} className="" key={i}>
                    {el}
                  </Dropdown.Item>
                ))}
              </DropdownButton>
            </div>
            {year && (
              <div className="float-end me-4">
                {" "}
                <DropdownButton
                  title={month ? <> {month}</> : <> Select month </>}
                  id="select-media-box"
                  onSelect={(e) => setMonth(e)}
                  className="  ms-2"
                >
                  {months.map((el, i) => (
                    <Dropdown.Item eventKey={el.lable} className="" key={i}>
                      {el.lable}
                    </Dropdown.Item>
                  ))}
                </DropdownButton>
              </div>
            )}
          </h2>
        </div>
        <div className="main-div">
          <BarChart filterData={filterD} filterInCartD={filterInCartD} />
        </div>
      </div>
    </div>
  );
};

export default Order;
